import { atom, selector, useSetRecoilState } from "recoil";
import { useAlert } from "../hooks/useAlert";
import { useCallback } from "react";
import { makeErrorMessage } from "../utils/ErrorMessageUtil";

export const alertListState = atom({
  key: 'alertListState',
  default: []
});

export const addAlertStateSelector = selector({
  key: 'addAlertStateSelector',
  set: ({get, set}, alertInfo) => {
    const oldList = get(alertListState);
    const idx = oldList.findIndex(target => {
      return target.id === alertInfo.id;
    });
    if (idx !== -1) return;
    const newList = [...oldList, alertInfo];
    set(alertListState, newList);
  },
  get: () => {}
});

export const removeAlertStateSelector = selector({
  key: 'removeAlertStateSelector',
  set: ({get, set}, alertInfo) => {
    const oldList = get(alertListState);
    const idx = oldList.findIndex(target => {
      return target.id === alertInfo.id;
    });
    if (idx === -1) return;

    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(alertListState, newList);
  },
  get: () => {}
});


export const removeDuplicateMessagesSelector = selector({
  key: 'removeDuplicateMessagesSelector',
  set: ({get, set}, message) => {
    const alertList = get(alertListState);
    const removeTarget = alertList.find(a => a.text === message);
    if (removeTarget) {
      set(removeAlertStateSelector, removeTarget);
    }
  },
  get: () => {}
});

export const useErrorMessage = () => {
  const removeDuplicateMessages = useSetRecoilState(removeDuplicateMessagesSelector);
  const {showError, removeAlert} = useAlert();

  const showErrorWithMessage = useCallback(message => {
    const errorMessage = makeErrorMessage(message);
    removeDuplicateMessages(errorMessage);
    return showError(errorMessage);
  }, [showError, removeDuplicateMessages]);

  const clearErrorMessage = useCallback(messageInfo => {
    removeAlert(messageInfo);
  }, [removeAlert]);

  return {
    showErrorWithMessage,
    clearErrorMessage
  };
};
